"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCard1 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var IconCard1 = function (_a) {
    var Icon = _a.Icon, _b = _a.iconBg, iconBg = _b === void 0 ? 'bp-C02-blue-50' : _b, title = _a.title, children = _a.children, linkText = _a.linkText, link = _a.link;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "bg-primary d-flex flex-column h-100 hover-shadow-lg text-center" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "p-7 x5-px-5 pt-10 flex-grow-1 d-flex flex-column" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "mb-6" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "d-inline-block position-relative square rounded-circle bg-".concat(iconBg, " text-dark") }, { children: (0, jsx_runtime_1.jsx)(Icon, { className: "absolute-center" }) })) })), (0, jsx_runtime_1.jsx)("h4", __assign({ className: "mb-3" }, { children: title })), (0, jsx_runtime_1.jsx)("p", __assign({ className: "opacity-80 mb-5" }, { children: children })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-auto" }, { children: (0, jsx_runtime_1.jsx)("a", __assign({ href: link, className: "text-default link-border" }, { children: linkText })) }))] })) })));
};
exports.IconCard1 = IconCard1;
